<template>
  <div v-if="loading" class="profile-container">
    <loader />
  </div>
  <div v-if="!loading" class="profile-container">
    <!-- HEADER -->
    <div class="header">
      <div class="profile-icon">👤</div>
      <div>
        <h2>{{ user.name }}</h2>
        <p class="username">{{ user.username }}</p>
      </div>
    </div>

    <hr />

    <!-- USER DETAILS SECTION -->
    <div class="section-title">User Details</div>

    <div class="details-grid">
      <div class="detail">
        <span class="label">Full Name: </span>
        <span class="value">{{ user.name }}</span>
      </div>

      <div class="detail">
        <span class="label">Email: </span>
        <span class="value">{{ user.email }}</span>
      </div>

      <div class="detail">
        <span class="label">Phone: </span>
        <span class="value">{{ user.phone }}</span>
      </div>

      <div class="detail">
        <span class="label">Role: </span>
        <span class="value">{{ user.gender }}</span>
      </div>

      <div class="detail">
        <span class="label">Country: </span>
        <span class="value">{{ user.country }}</span>
      </div>

      <div class="detail">
        <span class="label">User Create Date: </span>
        <span class="value">{{ formatDateTime(user.dob) }}</span>
      </div>
    </div>

    <!-- ACTION BUTTONS -->
    <div class="action-buttons">
      <button class="btn edit" @click="editing = true">Edit Details</button>
      <button class="btn password" @click="display_password_modal">
        Change Password
      </button>
    </div>

    <!-- EDIT DETAILS MODAL -->
    <div class="modal" v-if="editing">
      <div class="modal-content">
        <h3>Edit Profile</h3>

        <div class="form-group">
          <label>Name</label>
          <input v-model="editForm.name" />
        </div>

        <div class="form-group">
          <label>Email</label>
          <input v-model="editForm.email" />
        </div>

        <div class="form-group">
          <label>Phone</label>
          <input v-model="editForm.phone" />
        </div>

        <!-- <div class="form-group">
          <label>Country</label>
          <input v-model="editForm.country" />
        </div> -->

        <div class="modal-actions">
          <button class="btn cancel" @click="editing = false">Cancel</button>
          <button class="btn save" @click="saveEdit">Save</button>
        </div>
      </div>
    </div>
  </div>
  <forgot_password_modal
    v-if="show_change_pass_modal"
    @close-pass="show_change_pass_modal = false"
  />
</template>

<script>
import loader from "./special_clinics/dialysis/loader.vue";
import formatDateTime from "../timezone/utc_local_time";
import { generalApiRequest } from "../api/apiIndex";
import forgot_password_modal from "./forgot_password_modal.vue";
export default {
  name: "UserProfile",

  data() {
    return {
      show_change_pass_modal: false,
      loading: false,
      user: {
        name: "",
        username: "",
        email: "",
        phone: "",
        gender: "",
        country: "",
        dob: "",
      },

      editing: false,
      changingPassword: false,

      // Edit form
      editForm: {
        name: "",
        email: "",
        phone: "",
        country: "",
      },
    };
  },
  components: {
    forgot_password_modal,
    loader,
  },

  methods: {
    formatDateTime,
    display_password_modal() {
      this.show_change_pass_modal = true;
    },
    async get_user_details() {
      this.loading = true;
      const user = this.$store.getters.currentUser;
      // console.log(user);
      const resp = await generalApiRequest(
        "system_users/getbyid/" + user.id,
        "GET",
        {},
        1
      );

      const olduser = {
        name: resp.data.name,
        username: resp.data.email,
        email: resp.data.email,
        phone: resp.data.phone,
        gender: resp.data.role,
        country: "Kenya",
        dob: resp.data.created_at,
      };
      this.user = olduser;
      // console.log(olduser);
      this.editForm = { ...this.user };
      this.loading = false;
    },
    async saveEdit() {
      this.loading = true;
      const user = this.$store.getters.currentUser;

      const data = {
        name: this.editForm.name,
        email: this.editForm.email,
        phone: this.editForm.phone,
        id: user.id,
      };
      await generalApiRequest("storeSystemUser", "POST", data, 1);
      this.editing = false;
      await this.get_user_details();
      this.loading = false;
    },
  },

  mounted() {
    this.get_user_details();
  },
};
</script>

<style scoped>
.otp-row {
  display: flex;
  gap: 8px;
}

.send-otp {
  background: #1976d2;
  color: #fff;
  padding: 8px 12px;
  white-space: nowrap;
}
/* Layout */
.profile-container {
  max-width: 95%;
  margin: auto;
  background: #fff;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.07);
  font-family: "Segoe UI", sans-serif;
}

/* Header */
.header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.profile-icon {
  font-size: 65px;
  background: #e8e8e8;
  border-radius: 50%;
  padding: 18px;
}

.username {
  margin-top: -4px;
  font-size: 14px;
  color: #777;
}

/* Details grid */
.section-title {
  margin-top: 20px;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: 0.5px;
}

.details-grid {
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.detail .label {
  font-size: 12px;
  color: #666;
}
.detail .value {
  font-size: 14px;
  font-weight: 600;
}

/* Buttons */
.action-buttons {
  margin-top: 25px;
  display: flex;
  gap: 10px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.btn.edit {
  background: #1976d2;
  color: white;
}

.btn.password {
  background: #444;
  color: white;
}

.btn.cancel {
  background: #bbb;
}

.btn.save {
  background: #0d8345;
  color: #fff;
}

/* Modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.48);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  width: 380px;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  animation: fadeIn 0.2s ease;
}

.form-group {
  margin-bottom: 12px;
}

.form-group label {
  font-size: 12px;
  color: #555;
}

.form-group input {
  width: 100%;
  padding: 7px;
  margin-top: 3px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.modal-actions {
  margin-top: 15px;
  display: flex;
  justify-content: end;
  gap: 10px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
